namespace Matrix.Rebalancer {
    export interface TradeMacroForm {
        MacroCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        IsGlobalShortcut: Serenity.BooleanEditor;
        CustomPreProcessor: Serenity.StringEditor;
        CustomPostProcessor: Serenity.StringEditor;
        PermittedCashAccounts: Serenity.StringEditor;
        PermittedStrategies: Serenity.StringEditor;
        IsCashTransfer: Serenity.BooleanEditor;
        CashTransferAccountCode: FormatLookupEditor;
        CashTransferStrategies: Serenity.StringEditor;
        SessionId: Serenity.LookupEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        PhysicalWeight: Serenity.DecimalEditor;
        SyntheticWeight: Serenity.DecimalEditor;
        Deleted: Serenity.BooleanEditor;
        Steps: TradeMacroStepGrid;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TradeMacroForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.TradeMacro';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TradeMacroForm.init)  {
                TradeMacroForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = FormatLookupEditor;
                var w3 = s.LookupEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.DecimalEditor;
                var w6 = TradeMacroStepGrid;
                var w7 = StaticTextBlock;
                var w8 = ReadOnlyDateTime;

                Q.initFormType(TradeMacroForm, [
                    'MacroCode', w0,
                    'Description', w0,
                    'IsGlobalShortcut', w1,
                    'CustomPreProcessor', w0,
                    'CustomPostProcessor', w0,
                    'PermittedCashAccounts', w0,
                    'PermittedStrategies', w0,
                    'IsCashTransfer', w1,
                    'CashTransferAccountCode', w2,
                    'CashTransferStrategies', w0,
                    'SessionId', w3,
                    'DefaultSortOrder', w4,
                    'PhysicalWeight', w5,
                    'SyntheticWeight', w5,
                    'Deleted', w1,
                    'Steps', w6,
                    'CreatedBy', w7,
                    'CreatedWhen', w8,
                    'UpdatedBy', w7,
                    'UpdatedWhen', w8,
                    'Version', w7
                ]);
            }
        }
    }
}
